import { Button, CustomLabel, theme } from "@mindmemobile/mm-shared-global"; 
import styled from "styled-components";   

interface props {
  bgColor?: string;
  fontSize?: string | number;
}

export const HeaderContainer = styled.div<props>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.bgColor || theme.palette.primary.dark};
  padding: 10px;
  ${Button}, ${CustomLabel} {
    font-size: 12px;
    font-weight: 700;
  }
`;
